import { StaleOfflineCleanupAction, StaleOfflineCleanupActionKeys } from './typings';

export interface StaleOfflineCleanupState {
	staleIds: number[];
	dismissedForSession: boolean;
	isCleaningUp: boolean;
	autoCleanEnabled: boolean;
	preferencesLoaded: boolean;
}

const initialState: StaleOfflineCleanupState = {
	staleIds: [],
	dismissedForSession: false,
	isCleaningUp: false,
	autoCleanEnabled: false,
	preferencesLoaded: false,
};

export function staleOfflineCleanup(
	state: StaleOfflineCleanupState = initialState,
	action: StaleOfflineCleanupAction,
): StaleOfflineCleanupState {
	switch (action.type) {
		case StaleOfflineCleanupActionKeys.SET_STALE_IDS:
			return {
				...state,
				staleIds: action.staleIds,
				dismissedForSession: action.staleIds.length === 0 ? false : state.dismissedForSession,
			};

		case StaleOfflineCleanupActionKeys.DISMISS_FOR_SESSION:
			return {
				...state,
				dismissedForSession: true,
			};

		case StaleOfflineCleanupActionKeys.SET_CLEANING_UP:
			return {
				...state,
				isCleaningUp: action.isCleaningUp,
			};

		case StaleOfflineCleanupActionKeys.SET_AUTO_CLEAN_ENABLED:
			return {
				...state,
				autoCleanEnabled: action.autoCleanEnabled,
			};

		case StaleOfflineCleanupActionKeys.SET_PREFERENCES_LOADED:
			return {
				...state,
				preferencesLoaded: action.preferencesLoaded,
			};

		case StaleOfflineCleanupActionKeys.CLEAR:
			return {
				...state,
				staleIds: [],
				dismissedForSession: false,
				isCleaningUp: false,
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/StaleOfflineCleanup/reducer.ts